const plLimitUndefined = (element) => element.dataset.plLimit === undefined;

const professionalIndemnityNotSelected = () =>
  !Number($("#professional_indemnity").val());

const publicLiabilitySelected = (value) => Number(value) !== 0;

const professionalElWithoutEmployersLiability = () => {
  const $coverLimit = $("input[name=el_cover_limit]");
  return (
    $coverLimit.length > 0 &&
    $coverLimit.is(":checked") &&
    !$("#employers_liability_0").is(":checked")
  );
};

const hasNoEmployees = () => {
  const hasNoEmployees =
    $("#optional_public_liability").length > 0
      ? $("#optional_public_liability").attr("have-employees")
      : $("#public_liability").attr("have-employees");
  return hasNoEmployees !== "yes";
};

const plValidationNotRequired = (value, element) =>
  validate({
    plLimitUndefined: plLimitUndefined(element),
    publicLiabilitySelected: publicLiabilitySelected(value),
    professionalIndemnityNotSelected: professionalIndemnityNotSelected(),
    professionalElWithoutEmployersLiability:
      professionalElWithoutEmployersLiability(),
    hasNoEmployees: hasNoEmployees(),
  });

const validate = ({
  plLimitUndefined,
  publicLiabilitySelected,
  professionalIndemnityNotSelected,
  professionalElWithoutEmployersLiability,
  hasNoEmployees,
}) => {
  if (
    publicLiabilitySelected ||
    plLimitUndefined ||
    professionalIndemnityNotSelected
  )
    return true;
  if (professionalElWithoutEmployersLiability) return false;
  if (hasNoEmployees) return true;
  return false;
};

export {
  plLimitUndefined,
  professionalIndemnityNotSelected,
  publicLiabilitySelected,
  professionalElWithoutEmployersLiability,
  hasNoEmployees,
  plValidationNotRequired,
  validate,
};
